import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../../lib/routing";

export const consumptionRoutes: Array<RouteObject> = [
  {
    path: "*",
    id: "consumption",
    lazy: async () => convertRouteModule(await import("./index")),
    children: [
      { path: ":medium?", lazy: async () => convertRouteModule(await import("./application")) },
    ],
  },
];
